import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import cn from 'classnames';
import FormikAutocompleteSelect from '../Fields/FormikAutocompleteSelect';
import { fontSize } from '../../constants/styleConstants';
import * as languageIcons from '../../public/images/flags/index';
import ImageTag from '../ImageTag';

const useStyles = makeStyles(() => ({
  langSelect: {
    maxWidth: 150,
  },
}));

const LanguageSelect = ({ langs, name, value, label, onChange, className, errors, formikUse, ...rest }) => {
  const classes = useStyles();

  return (
    <FormikAutocompleteSelect
      instanceId={name || rest?.field?.name || 'language'}
      {...(formikUse
        ? {}
        : {
          field: {
            name,
            value,
          },
          onChange,
          preventDefaultOnChange: true,
        })}
      label={label}
      withFiltering
      customComponents={{
        Option: props => {
          const langObject = props.data;
          return (
            <MenuItem
              buttonRef={props.innerRef}
              selected={props.isFocused}
              style={{
                fontWeight: props.isSelected ? 800 : 400,
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                fontSize: fontSize.basic,
              }}
              {...props.innerProps}
            >
              <div>
                {languageIcons[`lang_${langObject?.slug}`] && (
                  <ImageTag src={languageIcons[`lang_${langObject?.slug}`]} alt={`${langObject?.slug} flag`} />
                )}{' '}
                {langObject?.name}
              </div>
            </MenuItem>
          );
        },
      }}
      options={langs}
      isEditable
      isClearable
      className={cn(classes.langSelect, className)}
      {...rest}
    />
  );
};

LanguageSelect.propTypes = {
  langs: PropTypes.array.isRequired,
  name: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  label: PropTypes.string,
  formikUse: PropTypes.bool,
};

LanguageSelect.defaultProps = {
  name: 'lang-select',
  label: '',
  formikUse: false,
};

export default LanguageSelect;
